import {AppPageHead} from './app.page.head';
import {AppPageTemplateConotent} from './app.page.template.content';
/**
 * 当前页面主体模块节点
 */
export class AppPageTemplate {
    constructor(){
        this.content = new AppPageTemplateConotent();
        this.head  = new AppPageHead();
    }
     /**
     * 模块名称
     */
    name: string;
    /**
     * 模块类型,表示当前模块类型
     */
    type: string;
    /**
     * 当前整体模块样式
     */
    class: string;
    /**
     * 当前整体模块的头部配置节点
     */
    head: AppPageHead;
    /**
     * 模块配置节点
     */
    content: AppPageTemplateConotent;
}